import { useApolloClient } from '@apollo/client';

import { GetRequestHeadersQuery } from '@notino/shared/definitions/types';

import getRequestHeadersQuery from '../queries/requestHeaders.graphql';

export const useApolloClientHeaders = (): NonNullable<
  GetRequestHeadersQuery['RequestHeaders']
> => {
  const { cache } = useApolloClient();

  const data = cache.readQuery<GetRequestHeadersQuery>({
    query: getRequestHeadersQuery,
  })!;

  return data.RequestHeaders!;
};
